import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarGrupoByIdService } from "../../../services/buscarGrupoByIdService";

export const useBuscarGrupoById = (
  grupoId: number | undefined | null,
  fetch: boolean
) => {
  const [grupo, setGrupo] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as grupo
  useEffect(() => {
    const fetchLead = async () => {
      if (grupoId && fetch) {
        setIsLoading(true);
        try {
          const data = await buscarGrupoByIdService(grupoId);
          if (data) {
            setGrupo(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar grupo:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchLead();
  }, [grupoId, fetch]);

  return { grupo, isLoading };
};
